<template>
    <div class="school-list">
        <div class="select-box">
            <div class="select-school" id="select" :style="selectStyle">
                <!-- <div class="close" @click="isBox = false"></div> -->
                <!-- <div class="title">选择学校</div> -->
                <div class="select-input">
                    <!-- <img class="search-icon" src="//file.40017.cn/appresource/image/forStudent/search@3x.png" /> -->
                    <!-- <p class="line-down"></p> -->
                    <input
                        type="text"
                        placeholder="请输入完整学校名称"
                        @input="navSchool(schoolname)"
                        v-model="schoolname"
                    />
                    <img v-show="schoolname" class="icon-box" src="https://file.40017.cn/appresource/image/forStudent/new/cer_icon_close@3x.png" @click="clearSchoolName" />
                </div>
                <div class="select-school-box">
                    <div class="select-null" v-if="schoollist.length == '0'">
                        <tc-empty
                            class="school-empty"
                            :type="'emptySearch_TC'"
                            style="height: 75vh;"
                            :btnTxt="''"
                            :tip="''"
                            :description="'未找到该学校'">
                        </tc-empty>
                    </div>
                    <div
                        class="select-item"
                        v-for="(item, index) in schoollist"
                        :key="index"
                        @click="selectSchool(index, item)"
                        :class="index == selectindex ? 'bg1' : ''"
                    >
                       {{ item }}
                    </div>
                </div>
                <!-- <p class="msg">
                    若未找到对应学校，可联系<span class="msg-text">95711</span>客服申报
                </p> -->
                <!-- <div
                    class="select-btn"
                    :class="btnstate ? 'o' : ''"
                    @click="defin(schoollist)"
                    >
                    确定
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import { getschoolData } from "@/api/studentCertification/certification"
import { Empty } from 'tc-business'
// import navb from "@/components/nav"
// import { Swipe, SwipeItem, Popup, Tab, Tabs, Sticky } from 'vant';
// import { defHttp } from "@/utils/http/axios";
// import TabsBox from './components/tabsBox.vue';
// import { toPage, toast, setEvent, cateEnum, baseUrl } from "@/utils/tool";

export default {
    name: 'forStudents',
    components: {
        [Empty.Component.name]: Empty.Component,
        //  navb,
        // TabsBox,
        // [Popup.name]: Popup,
    },
    data() {
        return {
            loginInfo: {},
            schoolData:[],// 学校数据
            schoollist:[],// 搜索数据
            schoolname:'',// 学校名称
            // school: {},
            selectindex:'-1', //选中位置
            clientHeight:"", //视窗大小
            btnstate:true, //确定按钮状态
            // 兼容输入法样式
            selectStyle:{
                top:""
            },
            images: [
                '//file.40017.cn/appresource/image/forStudent/banner@3x.png',
                'https://img01.yzcdn.cn/vant/apple-2.jpg',
            ],
            tabList: [
                {
                    id: 1,
                    title: '酒店'
                },
                {
                    id: 2,
                    title: '机票'
                }
            ],
            tabActive: 0,
            selectCity: {
                cityName: '上海',
                cityId: '0201'
            },
            filterList: [
                {
                    id: 1,
                    filterName: '毕业旅行'
                },
                {
                    id: 2,
                    filterName: '毕旅行'
                },
                {
                    id: 2,
                    filterName: '峰哥行'
                },
                {
                    id: 2,
                    filterName: '毕发发发'
                }
            ],
            cityData: {
                hotCitys: [],
                allCitys: [],
            },
            activeIndex: 0
        }
    },
    created() { 
         _multi_bridge_ready(() => {
            const that = this 
            window._tc_bridge_bar?.set_navbar({
                param: {
                    center: [{ tagname: "title", value: '选择学校' }]
                },
                callback: (data) => {}
            })
            window._tc_bridge_user?.get_device_info({
                param: {},
                callback: function (data) {
                    const dbody = JSON.parse(data.CBData);
                    const deviceInfo = dbody.deviceInfo;
                    that.deviceInfo = dbody.deviceInfo;
                    console.log('设备信息', deviceInfo.statusBarHeightPx);
                    if (window._tc_bridge_public.platform == 1) {
                        //安卓
                        // that.statusHei = deviceInfo.statusBarHeightPx / 3;
                    } else {
                        // that.statusHei = deviceInfo.statusBarHeightPx;
                    }
                }
            });
            window._tc_bridge_user?.user_login({
                callback: (res) => {
                    const data = JSON.parse(res.CBData);
                    console.log('1111登录信息111111111', data);
                    this.loginInfo = data.memberInfo
                    this.userKey = data.memberInfo.memberId
                    this.nickName = data.memberInfo.nickName
                    if (this.userKey) {
                        this.getschool()
                    }
                }
            })
         })
    },
    mounted() {
    },
    computed: {
    },
    methods: {
         // 获取学校数据
        getschool(){
            this.$loading.show({ type: 'part' });
            let paramsData = {
                headers: {
                    apptoken: this.loginInfo.memberIdNew,
                    memberId: this.loginInfo.memberId
                },
                params: {}
            }
            console.log('发起学校数据请求11', paramsData);
            getschoolData(paramsData).then(data => {
                console.log('123school', data)
                let content=data.content
                if(content){
                    this.schoolData=content
                    this.schoollist=content
                    this.navSchool()
                }
                else{
                    this.toast('学校获取失败')
                }
                this.$loading.hide()
            }).catch(()=> {
                this.$loading.hide()
            })
        },
        clearSchoolName(){
            this.schoolname=''
            this.navSchool('')
        },
        // 搜索框值改变事件
        navSchool(value){
            this.selectindex='-1'
            this.schoollist=[]
            console.log('school搜索框值', value);
            if(!value){
                this.toploade(this.schoolData)
                this.num=''
                this.schoollist=this.schoolData.slice(0,100)
                // alert('值为空')
                return
            }
            for(let i=0; i < this.schoolData.length; i++){
                let x=value 
                let reg=new RegExp(x)
                if(reg.test(this.schoolData[i])){
                 this.schoollist.push(this.schoolData[i])
                }  
            }
            if(this.schoollist.length=='1'){
                this.btnstate=false
            }
            else{
                this.btnstate=true
            }
        },
        // 上滑加载事件
        toploade(value){
            document.querySelector('.select-school-box').onscroll = ()=>{
                var  scrollH = document.querySelector('.select-school-box').offsetHeight
                var  scrollT = document.querySelector('.select-school-box').scrollTop
                this.num = this.num || 100
                if((scrollH * (this.num/14 - 1) - this.num * 16) - scrollT < 10){
                    this.num += 100
                    const tempList = this.schoolname ? this.schoollist : value
                    this.schoollist=tempList.slice(0,this.num)
                }
            }
        },
        // 选择学校
        selectSchool(index,item){
            this.selectindex=index
            this.schoolname=item
            // this.school.value=item
            // localStorage.setItem('school', item)
            setTimeout(() => {
                // this.isBox=false
                window._tc_bridge_web.data_callback({
                    param: {
                        "result": String(item)
                    },
                    callback: function () {
                        console.log('xxxxxxxxxxxx123243');
                    }
                })
            }, 500);
        },
        // 确认学校
        defin(schoollist){
            console.log(schoollist);
            if(schoollist.length=='1'){
                this.isBox=false
                this.school.value=schoollist[0]
            }
        },


    },
}
</script>
<style lang="less" scoped>
.school-list {
    // 学校选择
    position: relative;
    padding: 0 12px;
    background: #fff;
    height: 100vh;
    .select-box{
        // width: 100%;
        // height: 100%;
        // margin: 0px;
        // background: rgba(0,0,0,.75);
        .select-school{
            padding-top: 12px;
        // height: 100%;
        .close{
            position: absolute;
            top: 18px;
            right: 18px;
            width: 13px;
            height: 13px;
            background: url('//file.40017.cn/touchweixinqq/blackwhale/imgnew/close_b6.png');
            background-size: 100% 100%;
        }
        .title{
            // width: 100%;
            margin-top: 32px;
            text-align: center;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #010101;
        }
        .select-input{
            position: relative;
            display: flex;
            align-items: center;
            height: 40px;
            // margin: 0 auto;
            line-height: 40px; 
            background: #F6F8FB;
            border-radius: 22px;
            font-size: 14px;
            color: #B2B2B2;
            .search-icon {
                width: 19px;
                height: 19px;
                object-fit: contain;
                margin-left: 11px;
            }
            // .line-down {
            //     width: 2px;
            //     height: 24px;
            //     background: #04C597;
            //     margin: 0 3px;
            // }
            input {
                width: 95%;
                border: none;
                text-indent: 15px;
                caret-color: #04C597; // 设置光标颜色
                color: #333;
                background: transparent;
            }
            .icon-box {
                position: absolute;
                top: 9px;
                right: 12px;
                width: 22px;
                height: 22px;
            }
        }
        .select-school-box {
            // width: 335px;
            height: 680px;
            background: #fff;
            margin: 0 auto;
            margin-top: 5px;
            overflow: hidden;
            overflow-y: scroll;
            -webkit-overflow-scrolling:touch;
            // border: 1px solid #3333;
            .select-null {
                width: 100%;
                // height: 40px;
                text-align: center;
                line-height: 40px;
                font-size: 15px;
                font-weight: 600;
                color: #333333;
            }
            .select-item {
                width: 335px;
                height: 22px;
                line-height: 22px;
                padding-left: 16px;
                font-size: 16px;
                color: #333333;
                margin-top: 16px;
                &.bg1 { // 背景色
                    background: #E9EDF0;
                }

            }
        }
        .msg {
            width: 100%;
            margin-top: 25px;
            text-align: center;
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999999;
            .msg-text{
            color: #5EC5FF;
            }
        }
        .select-btn {
            width: 100%;
            height: 68px;
            margin-top: 16px;
            line-height: 68px;
            text-align: center;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #5EC5FF;
            border-top: 1px solid #E4E4E4;
        }
        }
        // 选择学历
        .select-status {
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 3;
            width: 7.49rem;
            height: 7.76rem;
            background: #FFFFFF;
            border-radius: 0.2rem 0.2rem 0px 0px;
            .close {
            position: absolute;
            top: 0.6rem;
            right: 0.3rem;
            width: 0.22rem;
            height: 0.22rem;
            background: url('//file.40017.cn/touchweixinqq/blackwhale/imgnew/close_b6.png');
            background-size: 100% 100%;
            }
            .title {
            margin-left: 0.64rem;
            margin-top: 0.68rem;
            font-size: 0.38rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
            }
            .status-list {
                margin-top: 0.49rem;
                margin-left: 0.74rem;
                font-size: 0.34rem;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #333333;
            }
        }
    }
}
</style>